/* COVA best selling: explore opens the product slider, close folds it back */
(function () {
  'use strict';
  function ready(fn) { if (window.CV && window.CV.register) fn(); else window.addEventListener('load', fn); }
  ready(function () {
    CV.register('[data-cv-bs]', function (root) {
      function set(open) {
        root.classList.toggle('is-open', open);
        var sw = root.querySelector('.cv-bs__slider');
        if (sw && sw.swiper) window.setTimeout(function () { sw.swiper.update(); }, 720);
      }
      var o = root.querySelector('[data-cv-bs-open]');
      var c = root.querySelector('[data-cv-bs-close]');
      if (o) o.addEventListener('click', function () { set(true); });
      if (c) c.addEventListener('click', function () { set(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) set(false); });
    });
  });
})();
